module.exports = __webpack_public_path__ + "AnchitChoudhary-9168e73d.webp";